import { ulid } from 'ulid';

import { getAnonymousId, setAnonymousId } from '~/utils/storage';

function generateUlid(): string {
  return ulid();
}

export function getOrCreateAnonymousId(): string {
  let storedId = getAnonymousId();

  if (!storedId) {
    storedId = generateUlid();
    setAnonymousId(storedId);
  }

  return storedId;
}
